const doesDeviceNeedDirectHapticTarget = isVibrationApiSupported => typeof navigator !== "undefined" && Boolean(navigator.maxTouchPoints) && !isVibrationApiSupported;
export { doesDeviceNeedDirectHapticTarget };